// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-sign-index-module__frame-MDeBnz {
  background: linear-gradient(173deg, #ecf4ff -.79%, #d3e1ff 94.5%);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__frame-MDeBnz .\\------packages-components-bot-semi-src-components-ui-sign-index-module__brand-yLKSC_ {
  color: #000;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  position: absolute;
  top: 16px;
  left: 24px;
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__frame-MDeBnz .\\------packages-components-bot-semi-src-components-ui-sign-index-module__brand-yLKSC_ .\\------packages-components-bot-semi-src-components-ui-sign-index-module__img-W1nxvt {
  padding-right: 12px;
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__frame-MDeBnz .\\------packages-components-bot-semi-src-components-ui-sign-index-module__brand-yLKSC_ .\\------packages-components-bot-semi-src-components-ui-sign-index-module__img-W1nxvt > img {
  width: 32px;
  height: 32px;
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__panel-PcNBZF {
  background: #fff;
  border: 1px solid rgba(28, 31, 35, .08);
  border-radius: 12px;
  width: 482px;
  height: 642px;
  padding: 40px 64px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .1), 0 0 1px rgba(0, 0, 0, .3);
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-frame-yNGAc2 {
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
}

.\\------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-panel-jVOVwq {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 4.88rem 2.5rem 1.88rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `------packages-components-bot-semi-src-components-ui-sign-index-module__frame-MDeBnz`,
	"brand": `------packages-components-bot-semi-src-components-ui-sign-index-module__brand-yLKSC_`,
	"img": `------packages-components-bot-semi-src-components-ui-sign-index-module__img-W1nxvt`,
	"panel": `------packages-components-bot-semi-src-components-ui-sign-index-module__panel-PcNBZF`,
	"mobile-frame": `------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-frame-yNGAc2`,
	"mobileFrame": `------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-frame-yNGAc2`,
	"mobile-panel": `------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-panel-jVOVwq`,
	"mobilePanel": `------packages-components-bot-semi-src-components-ui-sign-index-module__mobile-panel-jVOVwq`
};
export default ___CSS_LOADER_EXPORT___;
